import { render } from "./AllAlertsSectionAbout.vue?vue&type=template&id=2ac5ac08"
import script from "./AllAlertsSectionAbout.vue?vue&type=script&lang=js"
export * from "./AllAlertsSectionAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__